<form [formGroup]="parentFormGroup">
  <mat-form-field class="countries-selector-control">
    <mat-select multiple [formControlName]="controlName" [placeholder]="placeholderText">
      @for (item of countries$ | async; track item.isoAlpha2Name) {
        <mat-option [value]="item.isoAlpha2Name">
          {{item.name}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</form>
